import { ThemeEvents } from '@theme/events';

class ProductDispatch extends HTMLElement {
  connectedCallback() {
    if (this.abortController) return;
    this.abortController = new AbortController();
    const options = { signal: this.abortController.signal };
    this.scope = this.closest('[data-bb-variant-scope], .shopify-section');
    this.scope?.addEventListener(ThemeEvents.variantUpdate, (event) => this.updateVariant(event), options);
    this.scope?.addEventListener('blankabox:variant-change', (event) => this.updateStock(event.detail?.variantId), options);
    document.addEventListener(ThemeEvents.cartUpdate, (event) => this.updateCart(event.detail?.resource || event.detail?.cart), options);
    document.addEventListener('blankabric:cart-updated', (event) => this.updateCart(event.detail?.cart), options);
    const variantId = this.scope?.querySelector('product-form-component input[name="id"]')?.value;
    if (variantId) this.updateStock(variantId);
  }

  disconnectedCallback() {
    this.abortController?.abort();
    this.abortController = null;
  }

  updateVariant(event) {
    const data = event.detail?.data || {};
    const productId = data.productId || event.target?.dataset?.productId;
    if (!data.newProduct && productId && String(productId) !== this.dataset.productId) return;
    const next = [...(data.html?.querySelectorAll('bb-product-dispatch') || [])]
      .find((card) => card.dataset.blockId === this.dataset.blockId);
    if (next) {
      Object.assign(this.dataset, next.dataset);
      this.replaceChildren(...next.childNodes);
    }
    this.updateStock(event.detail?.resource?.id);
  }

  updateStock(variantId) {
    let variants;
    try {
      variants = JSON.parse(this.querySelector('[data-bb-dispatch-variants]')?.textContent || '[]');
    } catch {
      return;
    }
    const variant = variants.find((item) => String(item.id) === String(variantId));
    const inStock = variant?.in_stock === true;
    const title = this.querySelector('[data-bb-dispatch-title]');
    const message = this.querySelector('[data-bb-dispatch-message]');
    const icon = this.querySelector('[data-bb-dispatch-icon]');
    const badge = this.querySelector('[data-bb-dispatch-stock-badge]');
    this.dataset.stockState = inStock ? 'in_stock' : 'out_of_stock';
    if (title) title.textContent = inStock ? this.dataset.inStockTitle : this.dataset.outOfStockTitle;
    if (badge) {
      badge.textContent = inStock ? variant.low_stock_label || '' : '';
      badge.hidden = !badge.textContent;
    }
    if (message) {
      if (inStock) message.innerHTML = this.dataset.inStockMessage;
      else message.textContent = this.dataset.outOfStockMessage;
    }
    icon?.setAttribute('d', inStock ? 'm7 12 3 3 7-7' : 'M7 12h10');
  }

  async updateCart(cart) {
    if (!Array.isArray(cart?.items)) {
      try {
        const response = await fetch(this.dataset.cartUrl, { headers: { Accept: 'application/json' } });
        if (!response.ok) return;
        cart = await response.json();
      } catch {
        return;
      }
    }
    if (!Array.isArray(cart?.items)) return;
    this.dataset.cartTotal = String(cart.items.reduce((total, item) =>
      String(item.properties?._bb_gift_roulette || '') === 'true' ? total : total + Number(item.final_line_price || 0), 0));
    this.dispatchEvent(new CustomEvent('blankabric:delivery-progress', { bubbles: true }));
  }
}

if (!customElements.get('bb-product-dispatch')) {
  customElements.define('bb-product-dispatch', ProductDispatch);
}
